var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIsFAIconReady } from "@icon/fontawesome/useIsFAIconReady";
import { SkeletonLoader } from "@widget/loaders";
/**
 * @export
 *
 * Wrapper for FontAwesomeIcon component.
 * This will show a loading state(skeleton loader) untill the icon is ready/available, then render the actual icon
 *
 * Usage is the same as FontAwesomeIcon, additionally you can donfigure how skeleton loeader will render `skeletonLoader`
 *
 * @example
 *
 * ```
 * <FontAwesomeIconWrapper
 *    icon={['fal', 'bars']}
 * />
 * ```
 *
 * @example
 *
 * ```
 * <FontAwesomeIconWrapper
 *    icon={['fal', 'bars']}
 *    skeletonLoader={{
 *       width: '100%',
 *       height: '100%',
 *       additionalStyle={{
 *          borderRadius: '50%',
 *          aspectRatio: '1'
 *      }}
 *    }}
 * />
 * ```
 */
export const FontAwesomeIconWrapper = (props) => {
    const { skeletonLoader, icon } = props, rest = __rest(props, ["skeletonLoader", "icon"]);
    const ready = useIsFAIconReady(icon);
    if (!ready) {
        const defaultSkeletonProps = {
            width: "100%",
            height: "100%",
            additionalStyle: {
                borderRadius: "50%",
                aspectRatio: "1",
            }
        };
        const mergedSkeletonProps = skeletonLoader
            ? Object.assign(Object.assign(Object.assign({}, defaultSkeletonProps), skeletonLoader), { additionalStyle: Object.assign(Object.assign({}, defaultSkeletonProps.additionalStyle), skeletonLoader.additionalStyle) }) : defaultSkeletonProps;
        return _jsx(SkeletonLoader, Object.assign({}, mergedSkeletonProps));
    }
    return _jsx(FontAwesomeIcon, Object.assign({ icon: icon }, rest));
};
